"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var react_1 = __importDefault(require("react"));
var ButtonField_1 = require("./ButtonField");
var CategoryField_1 = require("./CategoryField");
var ImageField_1 = require("./ImageField");
var InquireButtonField_1 = require("./InquireButtonField");
var LinkField_1 = require("./LinkField");
var PdfField_1 = require("./PdfField");
var ProductField_1 = require("./ProductField");
var TextField_1 = require("./TextField");
var TitleField_1 = require("./TitleField");
var VideoField_1 = require("./VideoField");
var contentsRender = function (indexData, fieldDatas) {
    return fieldDatas.map(function (fieldData, index) {
        if (fieldData.type === "image") {
            if (fieldData.data.link)
                return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                    react_1.default.createElement(ImageField_1.LinkImageField, { imageData: fieldData })));
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(ImageField_1.ImageField, { imageData: fieldData })));
        }
        if (fieldData.type === "text") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(TextField_1.TextField, { textData: fieldData })));
        }
        if (fieldData.type === "link") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(LinkField_1.LinkField, { linkData: fieldData })));
        }
        if (fieldData.type === "title") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(TitleField_1.TitleField, { titleData: fieldData })));
        }
        if (fieldData.type === "button") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(ButtonField_1.ButtonField, { buttonData: fieldData })));
        }
        if (fieldData.type === "category") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(CategoryField_1.CategoryField, { categoryData: fieldData })));
        }
        if (fieldData.type === "pdf") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(PdfField_1.PdfField, { pdfData: fieldData })));
        }
        if (fieldData.type === "product") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(ProductField_1.ProductField, { productData: fieldData })));
        }
        if (fieldData.type === "video") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(VideoField_1.VideoField, { videoData: fieldData })));
        }
        if (fieldData.type === "inquire") {
            return (react_1.default.createElement(react_1.default.Fragment, { key: "field" + indexData + index },
                react_1.default.createElement(InquireButtonField_1.InquireButtonField, { buttonData: fieldData })));
        }
    });
};
var Field = function (_a) {
    var _b = _a.indexData, indexData = _b === void 0 ? "0" : _b, data = _a.data;
    return react_1.default.createElement(react_1.default.Fragment, null, contentsRender(indexData, data));
};
exports.Field = Field;
